import React from "react";
import { useContent } from "@/lib/content";
import { getIcon } from "@/lib/icons";

export default function USPs() {
  const { content } = useContent();
  const usps = content.usps || [];

  return (
    <section id="why" data-testid="usps-section" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl">
          <p className="font-inter text-sm font-semibold tracking-[0.18em] uppercase text-[#002570]">
            {content.usps_eyebrow || "Why Choose Educators"}
          </p>
          <h2 className="mt-3 font-rubik text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0f172a] leading-tight text-balance">
            {content.usps_headline_pre || "We don't just teach."} <span className="text-[#002570]">{content.usps_headline_emphasis || "We ensure you pass and get placed."}</span>
          </h2>
          {content.usps_subtitle && (
            <p className="mt-4 font-inter text-base md:text-lg text-slate-600 max-w-2xl">{content.usps_subtitle}</p>
          )}
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {usps.map((u, i) => {
            const Icon = getIcon(u.icon);
            return (
              <div
                key={i}
                data-testid={`usp-card-${i}`}
                className="group bg-[#f8fafc] rounded-2xl p-6 border border-slate-100 hover:border-[#73c3ff]/60 hover:bg-white hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-[#73c3ff]/20 text-[#002570] flex items-center justify-center mb-5 group-hover:bg-[#002570] group-hover:text-white transition-colors">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="font-rubik text-lg font-semibold text-[#0f172a]">{u.title}</h3>
                <p className="mt-2 font-inter text-sm text-slate-600 leading-relaxed">{u.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
